import * as React from 'react'

import { createProjectionsContext } from 'modules/core/components/DataTable/contexts/ProjectionsContext'

export default function useProjections<T, SourceFields extends string>() {
  const value = React.useContext(createProjectionsContext<T, SourceFields>())

  if (!value) {
    throw new Error('useProjections must be used within a ProjectionsProvider')
  }

  return value
}
